<template>
    <vx-table class="xl:grid-cols-[minmax(0,1fr)_auto_auto] mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div>Name</div>
            <div>Phone</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script lang="ts" setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
